import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const StarFull = props =>
	<svg viewBox="0 0 19 19" {...props}>
		<path d="M3.844 18.458a.507.507 0 01-.302-.097.524.524 0 01-.206-.506l.983-5.76L.156 8.018a.51.51 0 01-.129-.53.517.517 0 01.415-.352l5.752-.841 2.573-5.239A.513.513 0 019.23.77a.52.52 0 01.463.287l2.572 5.239 5.756.841a.517.517 0 01.282.882l-4.162 4.077.982 5.76a.521.521 0 01-.205.506.509.509 0 01-.544.04l-5.148-2.718-5.15 2.718a.51.51 0 01-.233.057z" />
	</svg>;

StarFull.propTypes = {
	fill: PropTypes.string,
};

StarFull.defaultProps = {
	fill: getColor('gray'),
	width: '1em',
	height: '1em',
};

export default StarFull;

// eslint-disable-next-line react/display-name
export const StarFullColored = (color) => (props) => <StarFull {...props} fill={getColor(color)} />;
